"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const tracking_1 = require("@cortex/tracking");
const button_1 = __importDefault(require("@kawaui/button"));
const loader_1 = require("@kawaui/loader");
const custom_hooks_1 = require("@user-engagement/custom-hooks");
const message_card_1 = __importStar(require("@user-engagement/message-card"));
const react_1 = require("react");
const constants_1 = require("./constants");
const Styled = __importStar(require("./styles"));
const utils_1 = require("./utils");
const MessageAnchor = (aProps) => (0, jsx_runtime_1.jsx)(Styled.Anchor, Object.assign({}, aProps));
const MessagesCenter = ({ pageName, emptyTitle, emptySubtitle, emptyButtonName, errorTitle, errorSubtitle, errorRefreshButtonName, errorReturnButtonName, memberId, siteId, path, isLight, linkWrapper, isMyNotificationsPage, }) => {
    const { data, loading, error } = (0, custom_hooks_1.useQuery)(`${path ? path : ''}/api/notification/v1/messages`, constants_1.MESSAGE_SECTIONS_KEY, memberId, siteId, path);
    const { track } = (0, tracking_1.useTracking)();
    const { messageSections, setMessageSections, unreadMessageCount, setUnreadMessageCount } = (0, custom_hooks_1.useMessageCenterContext)();
    const LinkWrapper = linkWrapper ? linkWrapper : MessageAnchor;
    const onTrackClickBanner = (sectionIndex, bannerIndex) => {
        const section = messageSections[sectionIndex];
        const banner = section.messages[bannerIndex];
        const nbPreviousBanner = sectionIndex > 0
            ? messageSections.reduce((total, section, idx) => {
                if (idx >= sectionIndex)
                    return total;
                return total + section.messages.length;
            }, 0)
            : 0;
        const trackingParams = (0, utils_1.extractDataFromUrlQuery)(banner.link.url);
        track('externallinkclick', {
            channel: 'MESSAGECENTER',
            trackingId: crypto.randomUUID(),
            siteId,
            urlId: trackingParams.urlId,
            urlName: trackingParams.urlName,
            messageId: banner.id,
            userAgent: navigator.userAgent,
            campaignId: banner.campaignId,
            partnerId: trackingParams.partnerId,
        });
        track('Click Notification Banner', Object.assign({ 'App Badge Activated': true, 'Optin Notif': true, '# of notifications': unreadMessageCount, 'Page Name': pageName, Category: section.title, 'Banner Position': nbPreviousBanner + bannerIndex, 'Position in category': bannerIndex, Redirection: banner.link.url, 'Banner type': banner.bannerType, 'Campaign ID': trackingParams.utmCampaign }, (banner.saleId && { 'Sale ID': banner.saleId })));
    };
    const refreshPage = () => window.location.reload();
    (0, react_1.useEffect)(() => {
        if (data) {
            setMessageSections(data);
            const nbBanners = data.reduce((total, section) => total + section.messages.length, 0);
            const { campaignIds, saleIds } = data.reduce((current, section) => {
                section.messages.forEach((banner) => {
                    if (banner.saleId) {
                        current.saleIds.push(banner.saleId);
                    }
                    const trackingParams = (0, utils_1.extractDataFromUrlQuery)(banner.link.url);
                    if (trackingParams.utmCampaign) {
                        current.campaignIds.push(trackingParams.utmCampaign);
                    }
                });
                return current;
            }, { campaignIds: [], saleIds: [] });
            track('Loads Account Page', {
                'App Badge Activated': true,
                'Optin Notif': true,
                '# of notifications': unreadMessageCount,
                'Page Name': isMyNotificationsPage ? 'My notifications' : 'My notifications homepage',
                '# of banners': nbBanners,
                'Campaign ID': campaignIds,
                'Sale IDs': saleIds,
            });
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        const isAllMessagesRead = messageSections && messageSections.every((section) => section.messages.every((message) => message.read));
        if (messageSections && !isAllMessagesRead) {
            setTimeout(() => {
                const readMessageSections = [...messageSections];
                readMessageSections.forEach((section) => section.messages.forEach((message) => (message.read = true)));
                const cachedData = localStorage.getItem(constants_1.MESSAGE_SECTIONS_KEY);
                if (cachedData) {
                    localStorage.setItem(constants_1.MESSAGE_SECTIONS_KEY, JSON.stringify(Object.assign(Object.assign({}, JSON.parse(cachedData)), { data: readMessageSections })));
                }
                const cachedMessageCount = localStorage.getItem(constants_1.UNREAD_MESSAGES_COUNT_KEY);
                if (cachedMessageCount) {
                    localStorage.setItem(constants_1.UNREAD_MESSAGES_COUNT_KEY, JSON.stringify(Object.assign(Object.assign({}, JSON.parse(cachedMessageCount)), { data: { unreadMessagesCount: 0 } })));
                }
                setMessageSections(readMessageSections);
                setUnreadMessageCount(0);
            }, constants_1.TIMEOUT_MARK_ALL_AS_READ);
        }
    }, [messageSections]);
    if (loading || (!loading && typeof error === 'undefined')) {
        return ((0, jsx_runtime_1.jsx)(Styled.MessagesCenterContainer, { "$isCentered": true, children: (0, jsx_runtime_1.jsx)("div", { "data-testid": "message-center-loader", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, {}) }) }));
    }
    if (error) {
        return ((0, jsx_runtime_1.jsxs)(Styled.EmptyOrErrorStateContainer, { "$isMyNotificationsPage": isMyNotificationsPage, children: [isMyNotificationsPage && ((0, jsx_runtime_1.jsx)(Styled.BackgroundImage, { "data-testid": "error-state-img", "$desktopImg": "https://media.veepee.com/v1/media/137731e0-c54b-4f5b-af4c-e8ca1a6511ba", "$tabletImg": "https://media.veepee.com/v1/media/f5649797-8e97-4f59-a45a-2d0aa2104d27", "$mobileImg": "https://media.veepee.com/v1/media/6f2a792e-04bf-4055-b867-5831a0fb5631" })), (0, jsx_runtime_1.jsxs)(Styled.TitleContainer, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { "$width": 270, children: errorTitle }), (0, jsx_runtime_1.jsx)(Styled.Subtitle, { "$width": 200, children: errorSubtitle })] }), (0, jsx_runtime_1.jsx)(Styled.ActionButtonWrapper, { "$width": isMyNotificationsPage ? 310 : 200, "$withMarginBottom": true, children: (0, jsx_runtime_1.jsx)(button_1.default, { isFullWidth: true, variant: "primary", size: "large", onClick: refreshPage, children: errorRefreshButtonName }) }), isMyNotificationsPage && ((0, jsx_runtime_1.jsx)(LinkWrapper, { href: "/gr/home/default", children: (0, jsx_runtime_1.jsx)(Styled.ActionButtonWrapper, { "$hasWhiteBackground": true, "$width": 310, children: (0, jsx_runtime_1.jsx)(button_1.default, { isFullWidth: true, variant: "secondary", size: "large", children: errorReturnButtonName }) }) }))] }));
    }
    if (messageSections && messageSections.length > 0) {
        return ((0, jsx_runtime_1.jsx)(Styled.MessagesCenterContainer, { children: messageSections.map((section, sectionIndex) => ((0, jsx_runtime_1.jsxs)(Styled.SectionContainer, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { children: section.title }), section.messages.map((message, msgIndex) => ((0, jsx_runtime_1.jsx)(message_card_1.default, Object.assign({ onClick: () => onTrackClickBanner(sectionIndex, msgIndex) }, message, (isLight && { variant: message_card_1.MessageCardVariant.LIGHT }), { linkWrapper: linkWrapper }), `section-${sectionIndex}-message-${msgIndex}`)))] }, `section-${sectionIndex}`))) }));
    }
    if (messageSections && messageSections.length === 0) {
        return ((0, jsx_runtime_1.jsxs)(Styled.EmptyOrErrorStateContainer, { "$isMyNotificationsPage": isMyNotificationsPage, children: [isMyNotificationsPage && ((0, jsx_runtime_1.jsx)(Styled.BackgroundImage, { "data-testid": "empty-state-img", "$desktopImg": "https://media.veepee.com/v1/media/7e7ce4a5-9fb3-4fbc-9c15-bc4012339dcd", "$tabletImg": "https://media.veepee.com/v1/media/7de921e9-970b-4929-a3aa-3262f6269f92", "$mobileImg": "https://media.veepee.com/v1/media/93799817-8ebb-429f-bc96-019243a1e454" })), (0, jsx_runtime_1.jsxs)(Styled.TitleContainer, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { children: emptyTitle }), (0, jsx_runtime_1.jsx)(Styled.Subtitle, { "$width": isMyNotificationsPage ? 310 : '100%', children: emptySubtitle })] }), (0, jsx_runtime_1.jsx)(LinkWrapper, { href: "/gr/home/default", children: (0, jsx_runtime_1.jsx)(Styled.ActionButtonWrapper, { "$width": 200, children: (0, jsx_runtime_1.jsx)(button_1.default, { isFullWidth: true, variant: "primary", size: "large", children: emptyButtonName }) }) })] }));
    }
};
MessagesCenter.defaultProps = {
    isLight: false,
};
exports.default = MessagesCenter;
